{
  "types": {
    "Instruction": [
      { "name": "salt", "type": "uint256" },
      { "name": "maxExecutions", "type": "uint256" },
      { "name": "action", "type": "address" },
      { "name": "uniswapV3ExactInput", "type": "UniswapV3ExactInput" }
    ],
    "UniswapV3ExactInput": [
      { "name": "recipient", "type": "address" },
      { "name": "tokenIn", "type": "address" },
      { "name": "tokenOut", "type": "address" },
      { "name": "feeTier", "type": "uint24" },
      { "name": "amountIn", "type": "uint256" },
      { "name": "floorAmountOut", "type": "uint256" },
      { "name": "meanPriceLookBack", "type": "uint32" },
      { "name": "maxPriceDeviationBPS", "type": "uint32" },
      { "name": "schedule", "type": "Schedule" },
      { "name": "fee", "type": "Fee" }
    ],
    "Schedule": [
      { "name": "startAt", "type": "uint256" },
      { "name": "startBy", "type": "uint256" },
      { "name": "interval", "type": "uint256" },
      { "name": "timeout", "type": "uint256" }
    ],
    "Fee": [
      { "name": "token", "type": "address" },
      { "name": "maxBaseFeePerGas", "type": "uint256" },
      { "name": "maxPriorityFeePerGas", "type": "uint256" },
      { "name": "executionFee", "type": "uint256" }
    ]
  }
}
